<script lang="ts">
	import { afterNavigate } from '$app/navigation';
	import { page } from '$app/state';
	import { mount } from 'svelte';
	import ContentCta from './ContentCta.svelte';
	import StrapiContent from './StrapiContent.svelte';

	interface Props {
		key: string;
		content: string;
		themes: BaseTheme[];
		category: string;
		disableArticleAd: boolean;
	}

	let { key, content, themes, category, disableArticleAd }: Props = $props();

	let contentElement: HTMLElement | undefined = $state();

	afterNavigate(() => {
		if (!contentElement) return;
		const h2s = Array.from(contentElement.querySelectorAll('h2'));
		const firstAdPlacement = h2s[0].textContent === 'TL;DR' ? 2 : 1;
		h2s.forEach((h2, i) => {
			if (!disableArticleAd) {
				if (i === firstAdPlacement) {
					const div = document.createElement('div');
					mount(ContentCta, {
						target: div,
						props: { position: 'Before second H2', themes, category }
					});
					h2.insertAdjacentElement('beforebegin', div);
				}

				if (h2s.length > 6 && i === 4) {
					const div = document.createElement('div');
					mount(ContentCta, {
						target: div,
						props: { position: 'Before fourth H2', themes, category }
					});
					h2.insertAdjacentElement('beforebegin', div);
				}

				if (i === h2s.length - 1 && i !== firstAdPlacement) {
					const div = document.createElement('div');
					mount(ContentCta, {
						target: div,
						props: { position: 'Before last H2', themes, category }
					});
					h2.insertAdjacentElement('beforebegin', div);
				}
			}
			if (h2.textContent) {
				if (page.url.hash === `#${h2.id}`) {
					h2.scrollIntoView();
				}
			}
		});
	});
</script>

{#key key}
	<div bind:this={contentElement} id="toc-builder-content">
		<StrapiContent {content} linksLocation="article-content" />
	</div>
{/key}
